import React from 'react';
import  BaglessDay2025  from 'views/BaglessDay2025';

const DesktopAppPage = () => {
  return <BaglessDay2025/>;
};
export default DesktopAppPage;
